export default __webpack_public_path__ + "static/media/LeftButton.ecc3a53d363584cac0a8a2943d6b9abc.svg";